import * as React from 'react';

interface ICalloutProps {
  bsStyle?: 'success' | 'info' | 'danger' | 'warning' | 'default';
  className?: string;
}

export default class Callout extends React.Component<ICalloutProps, {}> {

  static defaultProps: ICalloutProps = {
    bsStyle: 'default',
    className: ''
  };

  render() {
    return (
      <div className={`bs-callout bs-callout-${this.props.bsStyle} ${this.props.className}`}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/Callout.tsx